import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import { requestOrganizationById } from './graphql';
import { getOrgByID } from '../../graphql/organizationDetails';
import history from '../../config/history';
import AdminCaps from '../../config/searchFilters/AdminFilters';
import {
    // addUserRoute,
    // addProductRoute,
    // toolingManagementRoute,
    // addToolingRoute,
    //  downloadToolingRoute,
    // uploadToolingRoute,
    accountAdminRoute,
    // bidMatchingRoute,
} from '../../config/navigation/routes';
// import { mySupplierCaps } from '../EditSupplierCaps/EditSupplierCapsQL';

export default function AccountAdminHOC(AccountAdminPage) {
    class WrappedComponent extends Component {
        static propTypes = {
            auth: PropTypes.shape({
                jwtToken: PropTypes.string.isRequired,
                expiration: PropTypes.number.isRequired,
                organizationId: PropTypes.string.isRequired,
                role: PropTypes.string.isRequired,
                id: PropTypes.string.isRequired,
            }).isRequired,
            location: PropTypes.shape({
                pathname: PropTypes.string.isRequired,
            }).isRequired,
        };

        static initialState = {
            users: [],
            errors: [],
            isLoading: true,
            selectedMenu: AdminCaps.filters[0],
            orgName: '',
            loading: false,
            demoInitialValues: {},
            suppInitialValues: {},
            organizationsStatus: undefined,
            // toolFilter: undefined,
            orgCage: undefined,
        };

        state = WrappedComponent.initialState;

        async componentDidMount() {
            const {
                location: { pathname },
            } = this.props;
            const page = pathname.match(/([^/]*)\/*$/)[1];

            if (page === ':page' || page === 'home') {
                const url = accountAdminRoute.replace(':page', 'viewUsers');
                history.replace(url);
            } else {

                // const filter = {
                //     viewUsers: { text: 'View and edit Users', value: 'viewUsers' },
                //     addUser: { text: 'Add a new User', value: 'addUser' },
                //     companyDemo: { text: 'Edit Company Demographics', value: 'companyDemo' },
                //     myCapabilities: { text: 'Update Supplier Profile', value: 'myCapabilities' },
                //     // products: { text: 'View My Products', value: 'products' },

                // };

                const selectedMenu = AdminCaps.filters.find(menuItem => menuItem.value === page);
                this.setState({ selectedMenu });

            }
            const { organizationId } = this.props.auth;
            // const response = await requestOrganizationById(organizationId, id);
            const initialDemoValues = await getOrgByID(organizationId);

            // const initialSuppCaps = await mySupplierCaps(organizationId);
            const orgName =
                (initialDemoValues.organization && initialDemoValues.organization.name) || undefined;

            const orgCage =
                (initialDemoValues.organization && initialDemoValues.organization.cageCode) || undefined;
            const users =
                (initialDemoValues.organization && initialDemoValues.organization.users) || [];

            this.setState({
                // userOrgId: response.user.organizationId,
                orgName,
                users,
                orgCage,
                isLoading: false,
                demoInitialValues: { ...(initialDemoValues.organization || {}) },
                organizationsStatus: (initialDemoValues.organization && initialDemoValues.organization.iconStatus) || undefined,
            });
        }

        // async componentWillReceiveProps(nextProps) {
        //     if (this.props.auth.organizationId !== nextProps.auth.organizationId) {
        //         this.setState({
        //             isLoading: true,
        //         });
        //         const response = await requestOrganizationById(
        //             nextProps.auth.organizationId,
        //             nextProps.auth.id,
        //         );

        //         const orgCage =
        //             (response.organization && response.organization.cageCode) || undefined;
        //         const orgName =
        //             (response.organization && response.organization.name) || 'No-Name';
        //         const users =
        //             (response.organization && response.organization.users) || [];
        //         // let usersProcAuthority = [];
        //         // if (orgCage === "O0000") {
        //         //   usersProcAuthority = await requestUsersWithProcAuthority();
        //         // }
        //         // users.push(...usersProcAuthority);
        //         this.setState({
        //             isLoading: false,
        //             orgName,
        //             users,
        //             orgCage
        //         });
        //     }
        //     const pathname = nextProps.location.pathname;
        //     const page = pathname.match(/([^\/]*)\/*$/)[1];
        //     if (page === ':page' || page === 'home') {
        //         const url = accountAdminRoute.replace(':page', 'viewusers');
        //         history.replace(url);
        //     } else if (this.props.location !== nextProps.location) {
        //         const selectedMenu = AdminCaps.filters.find(menuItem => menuItem.value === page);
        //         this.setState({ selectedMenu });
        //     }
        // }

        refreshUsers = async () => {
            const { organizationId, id } = this.props.auth;
            this.setState({
                // users: response.organization.users,
                loading: true,
            });
            const response = await requestOrganizationById(organizationId, id);
            this.setState({ users: response.organization.users, loading: false });
        };

        refreshDemoInitialValues = async () => {
            console.log("refreshDemoInitialValues")
            const { organizationId } = this.props.auth;
            const initialDemoValues = await getOrgByID(organizationId);
            console.log(initialDemoValues)
            this.setState({
                demoInitialValues: initialDemoValues.organization,
            });
        }

        // _onNewUserClick = () => {
        //     const { users } = this.state;
        //     const newUser = {
        //         fullName: '',
        //     };
        //     const updatedUsers = [...users, newUser];
        //     this.setState({ users: updatedUsers, viewNewUserForm: true });
        // };

        _onFilterClick = filter => {
            this.setState({ selectedMenu: filter });
            let url;
            switch (filter.value) {
                // case 'newusers':
                //     history.push(addUserRoute);
                //     break;
                // case 'bidMatch':
                //     history.push(bidMatchingRoute);
                //     break;
                // case 'addproduct':
                //     history.push(addProductRoute);
                //     break;
                default:
                    url = accountAdminRoute.replace(':page', filter.value);
                    history.replace(url);

                    break;
            }
        };

        // _onToolFilter = e => {
        //     if (document.getElementById('niin').value !== '') {
        //         this.setState({
        //             toolFilter: { niin: document.getElementById('niin').value },
        //         });
        //     } else if (document.getElementById('partNum').value !== '') {
        //         this.setState({
        //             toolFilter: { partNum: document.getElementById('partNum').value },
        //         });
        //     } else if (document.getElementById('description').value !== '') {
        //         this.setState({
        //             toolFilter: {
        //                 description: document.getElementById('description').value,
        //             },
        //         });
        //     } else {
        //         this.setState({ toolFilter: undefined });
        //     }
        //     console.log(e.target.name, '<===>', e.target.value);
        // };

        // _onCountryChange = e => {
        //     const newInitialValues = {};
        //     newInitialValues.cntry = e;
        //     if (this.state.demoInitialValues.cntry !== e) newInitialValues.state = null;
        //     this.setState(
        //         {
        //             demoInitialValues: { ...this.state.demoInitialValues, ...newInitialValues },
        //         },
        //     );
        // };

        // _changeMetaDataBack = async orgId => {
        //   const { id } = this.props.auth;

        //   const res = await updateUserMetaData(id, orgId);
        //   if (res) {
        //     // gotta remove the cookie or it will load the old cookie info on the redirect

        //     document.cookie = 'idToken= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';

        //     window.location.replace(
        //       '/login?redirect=%2Fmemberadmin%2Fhome%2FviewUsers',
        //     );
        //   }
        // };

        render() {
            const {
                isLoading,
                users,
                selectedMenu,
                loading,
                demoInitialValues,
                suppInitialValues,
                orgName,
                // userOrgId,
                organizationsStatus,
                // toolFilter,
                orgCage,
            } = this.state;
            const { auth } = this.props;
            const pageProps = {
                organizationsStatus,
                orgCage,
                // userOrgId,
                orgName,
                auth,
                loading,
                users,
                isLoading,
                selectedMenu,
                demoInitialValues,
                // onCountryChange: this._onCountryChange,
                suppInitialValues,
                // changeMetaDataBack: this._changeMetaDataBack,
                refreshUsers: this.refreshUsers,
                refreshDemoInitialValues: this.refreshDemoInitialValues,
                onMenuClick: this._onFilterClick,
                viewNewUserForm: this.state.viewNewUserForm,
                // onToolFilter: this._onToolFilter,
                // toolFilter,
            };

            return <AccountAdminPage
                {...pageProps}
                orgCage={orgCage || ''}
                organizationsStatus={organizationsStatus || ''}
            />;
        }
    }

    return withRouter(WrappedComponent);
}



// WEBPACK FOOTER //
// ./src/pages/AccountAdmin/AccountAdminHOC.jsx